import React, { useCallback } from "react";
import "../Assets/Css/Table.css";
import { Column } from "primereact/column";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import Swal from "sweetalert2";
import { axiosConfig } from "../axiosAPI";
import { useAuth } from "../AuthProvider";
import GlobalDataTable from "../components/GlobalDataTable";

function rowMatchesKeyword(row, keyword) {
  const k = keyword.toLowerCase();
  const hay = [row.passengerFullName, row.driverFullName, row.fare, row.date, row.paymentMethod]
    .map((x) => String(x ?? "").toLowerCase())
    .join(" ");
  return hay.includes(k);
}

function withRowKeys(rows, pageNo, offsetInFiltered = 0) {
  return (Array.isArray(rows) ? rows : []).map((row, idx) => ({
    ...row,
    __rowKey: `p${pageNo}-i${offsetInFiltered + idx}-${row.passengerUuid}-${String(row.date)}-${row.fare}`,
  }));
}

function Payment() {
  const auth = useAuth();

  const fetchPaymentsPage = useCallback(
    async ({ pageNo, rowCount, keyword }) => {
      const headers = {
        Authorization: "Bearer " + auth.token,
        "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
      };
      const base = `${process.env.REACT_APP_BASE_URL}/dashboard/payments`;

      try {
        if (keyword) {
          const response = await axiosConfig.get(base, { headers });
          const all = Array.isArray(response.data.data.result) ? response.data.data.result : [];
          const filtered = all.filter((r) => rowMatchesKeyword(r, keyword));
          const start = (pageNo - 1) * rowCount;
          const slice = filtered.slice(start, start + rowCount);
          return {
            result: withRowKeys(slice, pageNo, start),
            totalCount: filtered.length,
          };
        }

        const params = new URLSearchParams({
          pageNo: String(pageNo),
          rowCount: String(rowCount),
        });
        const response = await axiosConfig.get(`${base}?${params.toString()}`, { headers });
        const raw = response.data.data.result;
        const totalCount = response.data.data.totalCount;
        return {
          result: withRowKeys(raw, pageNo, 0),
          totalCount,
        };
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        return { result: [], totalCount: 0 };
      }
    },
    [auth.token]
  );

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="table">
              <GlobalDataTable
                fetchPage={fetchPaymentsPage}
                defaultRowCount={10}
                rowCountOptions={[10, 20, 50, 100]}
                searchPlaceholder="Search passenger, driver, fare, date, payment method…"
                emptyMessage="No payments found."
                headerTitle={
                  <span>
                    <i className="fa fa-credit-card me-2"></i>
                    Payments
                  </span>
                }
                dataKey="__rowKey"
                showGridlines
                tableStyle={{ minWidth: "700px" }}
              >
                <Column field="passengerFullName" header="passenger" style={{ width: "20%" }}></Column>
                <Column field="driverFullName" header="driver" style={{ width: "20%" }}></Column>
                <Column field="fare" header="ride cost" style={{ width: "20%" }}></Column>
                <Column field="date" header="date" style={{ width: "20%" }}></Column>
                <Column field="paymentMethod" header="payment method" style={{ width: "20%" }}></Column>
              </GlobalDataTable>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payment;
